import styled from 'styled-components'
import { LuThumbsUp, LuThumbsDown } from 'react-icons/lu'

const Rating = ({ id }: { id: number }) => {
  const handleRate = (up: boolean) => {
    console.log(id, up)
  }

  return (
    <Container>
      <Thumb onClick={() => handleRate(true)}>
        <LuThumbsUp />
      </Thumb>
      <Thumb onClick={() => handleRate(false)}>
        <LuThumbsDown />
      </Thumb>
    </Container>
  )
}

const Container = styled.div`
    
`

const Thumb = styled.div`
  display: inline-block;
  width: 3rem;
  height: 3rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:first-child {
    margin-right: 0.5rem;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colorGrey};
  }
`

export default Rating
